import { Skeleton as _Skeleton } from 'antd';

import styled from 'styled-components';

const Skeleton = styled(_Skeleton)``;

export default Skeleton;
